<div class="modal-container">
  <h3 mat-dialog-title>{{ data.message }}</h3>

  <div mat-dialog-content>
    <!-- Sección tradicional de BCRA: Períodos y Situación -->
    <div class="bcra-traditional-section">
      <div class="form-row">
        <div class="form-field">
          <label class="efx-label">Período desde</label>
          <input
            [(ngModel)]="periodoini"
            placeholder="YYYYMM"
            maxlength="6"
            (keypress)="numberOnly($event)"
            class="efx-input"
            type="text"/>
          </div>

          <div class="form-field">
            <label class="efx-label">Período hasta</label>
            <input
              [(ngModel)]="periodofin"
              placeholder="YYYYMM"
              maxlength="6"
              (keypress)="numberOnly($event)"
              class="efx-input"
              type="text"/>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field full-width">
              <label class="efx-label">Situación</label>
              <select class="efx-select" [(ngModel)]="situacionSeleccionada">
                <option value="">Seleccione una situación</option>
                @for (sit of data.list; track sit) {
                  <option [value]="sit.code">
                    {{ sit.code + ': ' + sit.description }}
                  </option>
                }
              </select>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field full-width">
              <label class="efx-label">Motivo</label>
              <p class="motivo-static"><b>NOC: MODIFICACIÓN</b></p>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field full-width">
              <label class="efx-label">Comentarios</label>
              <input
                [(ngModel)]="comentarios"
                class="efx-input"
                type="text"
                placeholder="Ingrese comentarios opcionales"/>
              </div>
            </div>
          </div>

          <hr>

            <!-- Sección de campos editables dinámicos (como Trade) -->
            @if (data.availableFields && data.availableFields.length > 0) {
              <div class="detailed-edit-container">
                <h6 class="efx-title-6">Editar campos específicos adicionales:</h6>
                <form [formGroup]="form">
                  <div class="rows-container" formArrayName="camposUpdate">
                    @for (control of arrayUpdatesControl.controls; track control; let i = $index) {
                      <div class="edit-row" [formGroupName]="i">
                        <div class="form-field">
                          <label class="efx-label">Campo a modificar</label>
                          <select class="efx-select" formControlName="fieldToChange" (change)="control.patchValue({ newValue: null })" #selectField>
                            <option value="" disabled hidden>Seleccionar campo</option>
                            @for (field of getAvailableFields(i); track field) {
                              <option [value]="field.name">{{ field.label }}</option>
                            }
                          </select>
                        </div>
                        <div class="row-separator">
                          <p>=</p>
                        </div>
                        <div class="form-field">
                          <label class="efx-label">Nuevo Valor</label>
                          <div>
                            @switch (getInputType(i)) {
                              @case ('date') {
                                <input
                                  class="efx-input"
                                  type="date"
                                  formControlName="newValue"
                                  [disabled]="!selectField.value">
                              }
                              @case ('select') {
                                <select
                                  class="efx-select"
                                  formControlName="newValue"
                                  [disabled]="!selectField.value">
                                  <option [ngValue]="null" disabled hidden>Seleccionar</option>
                                  @for (opt of getSelectOptions(i); track opt) {
                                    <option [value]="opt.code">
                                      {{ opt.description }}
                                    </option>
                                  }
                                </select>
                              }
                              @case ('number') {
                                <input
                                  class="efx-input"
                                  type="number"
                                  formControlName="newValue"
                                  [disabled]="!selectField.value">
                              }
                              @default {
                                <input
                                  class="efx-input"
                                  type="text"
                                  formControlName="newValue"
                                  [disabled]="!selectField.value">
                              }
                            }
                          </div>
                        </div>
                        <div class="row-actions">
                          @if (i === arrayUpdatesControl.length - 1 && arrayUpdatesControl.length < 5) {
                            <button
                              type="button"
                              class="btn-icon btn-add"
                              (click)="agregarCampoVacio()">
                              <span class="material-symbols-outlined">add</span>
                            </button>
                          }
                          @if (arrayUpdatesControl.length > 0) {
                            <button
                              type="button"
                              class="btn-icon btn-delete"
                              (click)="eliminarCampo(i)">
                              <span class="material-symbols-outlined">delete</span>
                            </button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                  @if (arrayUpdatesControl.length === 0) {
                    <button
                      type="button"
                      class="efx-button-tertiary mt-2"
                      (click)="agregarCampoVacio()">
                      <span class="material-symbols-outlined">add</span> Añadir campo adicional
                    </button>
                  }
                </form>
              </div>
            }
          </div>

          <div mat-dialog-actions class="form-footer">
            <button class="efx-button-secondary" (click)="onNoClick()">Cancelar</button>
            <button class="efx-button-primary" (click)="onSubmit()" [disabled]="!isAnythingSelected()">Guardar</button>
          </div>
        </div>

